import React, { useEffect, useState } from "react";
import CountryFlag from "../../Components/CouontryFlag/CountryFlag";
import { getProductColor, getProductTag } from "../../Services/ProductService";
import { getStoreOnlineAll } from "../../Services/StoreOnlineService";
import ProductDetailInformationView from "./ProductDetailInformationView";
import ProductHighlightView from "./ProductHighlightView";
import ProductUSPHighlightView from "./ProductUSPHighlightView";
import ProductEcommerceView from "./ProductEcommerceView";

const ProductDetailPageView = ({ countryChange, state, setState }) => {
  let {
    productDetails,
    productDetail,
    productHighlights,
    manualBooks,
    activeSubTab,
    filesDescsNew,
    filesNew,
    filesUps,
    productUps,
    media_types,
    content_types,
    productEcom,
  } = state;

  if (!state.manualBooksDelete) state.manualBooksDelete = [];

  const [ecomState, setEcomState] = useState({ storeLoc: [] });
  const [detailState, setDetailState] = useState({
    productColors: [],
    productTags: [],
  });

  const handleTabClick = (tab) => {
    if (productDetails.length > 0) {
      setState({ ...state, activeSubTab: tab });
    }
  };

  const handleOpen = () => {
    setState({ ...state, show: !state.show });
  };

  const onLanguageClick = (item) => {
    manualBooks.map((item) => {
      const index = productDetails.findIndex((e) => e.manual_book == item[0].name);
      if (index > -1) {
        return item;
      }
    });
    const _productHighlights = [...productHighlights];
    const _productUps = [...productUps];
    const _filesUps = [...filesUps];

    const index = productDetails.findIndex((e) => e.language_code == item.language_code);
    const langIndex = _productHighlights.findIndex((e) => e.language_code == item.language_code);
    const _productHighlight =
      _productHighlights.length > 0
        ? _productHighlights[langIndex]
        : [
            {
              language_code: item.language_code,
              language_name: item.language_name,
              title: "",
              description: "",
            },
          ];

    const _productDetail = JSON.parse(JSON.stringify(productDetails[index]));

    setState({
      ...state,
      productDetail: _productDetail,
      filesUps: _filesUps,
      productHighlights: _productHighlights,
      productHighlight: _productHighlight,
      productUps: _productUps,
    });
  };

  useEffect(() => {
    if (countryChange != "" && productDetail.language_code != "") {
      const reqProductCode = getProductColor(countryChange, productDetail.language_code).then((res) => res.data);
      const reqProductTag = getProductTag(countryChange, productDetail.language_code).then((res) => res.data);
      const reqStoreOnline = getStoreOnlineAll({
        orders: "store_name:asc",
        perpage: 100,
      }).then((res) => res.data);

      Promise.all([reqProductCode, reqProductTag, reqStoreOnline]).then((results) => {
        const [_colors, _tags, _store] = results;

        setDetailState({
          ...detailState,
          productColors: _colors,
          productTags: _tags,
        });

        setEcomState({
          ...ecomState,
          storeLoc: _store.data,
        });
      });
    } else {
      setDetailState({ ...detailState, productColors: [], productTags: [] });
    }
  }, [countryChange, productDetail]);

  const { productColors, productTags } = detailState;
  const { storeLoc } = ecomState;

  const propsProductDetailInformation = {
    productDetail,
    productColors,
    productTags,
  };

  const propsProductHighlight = {
    filesNew,
    filesDescsNew,
    productDetail,
    productHighlights,
    media_types,
    content_types,
  };

  const propsProductUspHighlight = {
    productUps,
    productDetail,
    media_types,
    content_types,
  };

  const propsProductEcommerce = {
    productEcom,
    storeLoc,
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <p className="pt-2">Language :</p>

        <div className="col-md-12">
          <div className="form-group mt-2">
            <div className="d-flex flex-wrap">
              {productDetails.length > 0 ? (
                productDetails.map((item, i) => (
                  <div
                    key={`item-${i}`}
                    className={`btn btn${item.language_code == productDetail.language_code ? "-" : "-outline-"}warning btn-sm d-flex mr-2 mb-2`}
                  >
                    <a onClick={() => onLanguageClick(item)} type="button" style={{ minWidth: 100 }}>
                      <CountryFlag code={item.language_code} />
                      {item.language_name}
                    </a>
                  </div>
                ))
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
        <div className="accordian">
          <div className="accordian-header" onClick={handleOpen}>
            <p className="mb-2">Additional Information</p>
          </div>

          <div>
            <div className="tab">
              <p className={activeSubTab === "tab1" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab1")}>
                Product Detail
              </p>
              <p className={activeSubTab === "tab2" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab2")}>
                Product Highlight
              </p>
              <p className={activeSubTab === "tab3" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab3")}>
                USP Product Highlight
              </p>
              <p className={activeSubTab === "tab4" ? "tablinks active" : "tablinks"} onClick={() => handleTabClick("tab4")}>
                Product Ecommerce
              </p>
            </div>

            <div className="tabcontent">
              {activeSubTab === "tab1" && (
                <div>
                  <ProductDetailInformationView {...propsProductDetailInformation} />
                </div>
              )}
              {activeSubTab === "tab2" && (
                <div className="row">
                  <div className="col-md-12">
                    <ProductHighlightView {...propsProductHighlight} />
                  </div>
                </div>
              )}
              {activeSubTab === "tab3" && (
                <div className="row">
                  <div className="col-md-12">
                    <ProductUSPHighlightView {...propsProductUspHighlight} />
                  </div>
                </div>
              )}
              {activeSubTab === "tab4" && (
                <div className="row">
                  <div className="col-md-12">
                    <ProductEcommerceView {...propsProductEcommerce} />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailPageView;
